import { type DoctorBranchCode, api } from '@/lib/api-client'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

/** Taken slots (bookings + blocks) + branch doctors for one branch/day.
 * Sourced from Avixo's calendar_events feed (refreshed every 15 min). */
export function useSlots(branchCode: DoctorBranchCode, date: string) {
  return useQuery({
    queryKey: ['slots', branchCode, date],
    queryFn: () => api.slots.taken(branchCode, date),
    placeholderData: keepPreviousData,
    // The feed refreshes every 15 min upstream; 60s client staleTime is plenty.
    staleTime: 60 * 1000,
  })
}
